<!--  -->
<template>
  <div>
    666
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
